<template>
    <div>
        <div class="page-header-style">
            <ul class="nav nav-pills">
                <li class="disabled"><h4 style="margin-left:15px; margin:10px" class="text-primary"><b>{{controller.isNewUser ? "Create" : "Edit"}} User  {{controller.isNewUser ? "" : "-"}}  <em>{{carehome.name}} </em></b></h4></li>
                <!--<li class="pull-right">
                    <router-link :to="{ name: 'patient-create', params: { id: çarehomeId, name: carehomeName }}">
                        Add Patient
                    </router-link>
                </li>
                <li class="pull-right">
                    <router-link :to="{ name: 'charts', params: { carehomeid: carehomeId }}">
                        Print Charts
                    </router-link>
                </li>
                <li class="pull-right">
                    <router-link :to="{ name: 'carehome-dispensation', params: { carehomeid: çarehomeId}}">
                        MAR Status
                    </router-link>
                </li>-->
            </ul>
            <!--<hr style="margin-top:0px" />-->
        </div>
        <br/>
        <div class="col-md-12">

            <form class="form-horizontal">
                <fieldset>
                    <!--<legend>{{controller.isNewUser ? "Create" : "Edit"}} User<span style="margin:0px" class="text-primary pull-right"><em>{{carehome.name}} </em></span></legend>-->


                    <div class="col-md-9">
                        <div class="form-group "
                             v-bind:class="{ 'has-error' : controller.permissionType.hasError,'has-warning' : controller.permissionType.hasWarning ,'has-success' : controller.permissionType.hasSuccess}">

                            <label class="col-md-3 control-label">Carehome</label>
                            <div class="col-md-9">
                                <selectize :options="$root.$data.Carehomes"
                                           v-model="controller._carehome"
                                           labelField="name"
                                           valueField="id"
                                           searchField="name">
                                </selectize>
                            </div>
                        </div>
                        <fieldset :disabled="!controller.isNewUser">
                            <forminput v-bind:controller="controller.email"></forminput>
                        </fieldset>
                        <forminput v-bind:controller="controller.firstName"></forminput>
                        <forminput v-bind:controller="controller.lastName"></forminput>
                        <div class="form-group "
                             v-bind:class="{ 'has-error' : controller.permissionType.hasError,'has-warning' : controller.permissionType.hasWarning ,'has-success' : controller.permissionType.hasSuccess}">

                            <label class="col-md-3 control-label">User Type</label>
                            <div class="col-md-9">
                                <selectize :options="permissions"
                                           v-model="controller.permissionType.value"
                                           labelField="permissionName"
                                           valueField="permissionId"
                                           searchField="permissionName">
                                </selectize>
                            </div>
                        </div>
                    </div>
                </fieldset>
                <hr />

                <div class="form-group" v-bind:class="{ 'has-error' : controller.hasError,'has-warning' : controller.hasWarning ,'has-success' : controller.hasSuccess}">

                    <WorkerButton :disabled="controller.hasError" :submit="Submit" task="Patient Orders Saved"></WorkerButton>

                    <a href="#" class="btn btn-warning disabled">Reset</a>
                    <span class="help-block">{{controller.message}}</span>
                </div>
            </form>
        </div>
    </div>
</template>



<script>
    import { CarehomeUserFormController } from './CarehomeUserFormController'
    import WorkerButton from './../../corecontrols/workerbutton/workerbutton.scp.html';

    import { CarehomeDto } from './../../../dto/carehomedto'
    import { UserDto, UserPermissionDto } from "./../../../dto/Dtos";
    import Dal from './../../../scripts/dataaccess'
    import Formatter from "../../corecontrols/formatters/Formatter"
    import forminput from "../../corecontrols/forminput/forminput.scp.html"
    import formselect from "../../corecontrols/formselect/formselect.scp.html"
    import selectize from "../../corecontrols/selectize/selectize.scp.html"

    export default {
        props: {
            carehomeid: {
                type: String,
                required: true
            },

            userid: {
                type: String,
                required: false
            },
        },
        //props: ['carehomeid', 'userid'],
        data: function () {
            var formatDate = Formatter.FormatDate;
            var that = this;

            return {
                carehome: {},
                user: {},
                controller: new CarehomeUserFormController(),
                permissions: []
            }
        },
        created: function () {
            var dal = new Dal();
            if (!this.carehomeid) {
                this.carehomeid = this.$route.query.carehomeid;
                this.userid = this.$route.query.userid;
            }
            console.log("CarehomeUserForm Created with ", this.carehomeid, this.userid, this.$route.query.carehomeid, this.$route.query.userid)


            dal.GetPermissionTypes().then(types => {
                for (var type of types) {
                    if (type.permissionName.startsWith("Carehome")) {
                        this.permissions.push(type)
                    }
                }
            });

            var userid = this.userid;

            dal.GetCarehome(this.carehomeid).then(data => {

                this.carehome = data;
                this.user = null;
                console.log(this.userid);
                if (userid) {
                    dal.GetUsersForCarehome(this.carehomeid).then(users => {
                        console.log("users", users);
                        for (var user of users) {
                            if (userid == user.id) {
                                this.user = user;
                                console.log("CarehomeUserFormController", this.carehome, this.user)
                                this.controller.load(this.carehome, this.user)
                                break;
                            }
                        }
                    })
                }
                else {
                    this.controller.load(this.carehome, null)
                }
            })
        },
        methods: {

            createUser: function (callback) {
                var dal = new Dal();
            },

            Submit: function () {
                return this.controller.Submit();
            }

        },
        components: {
            Formatter,
            forminput,
            selectize,
            formselect,
            WorkerButton
        }
    }
</script>


// WEBPACK FOOTER //
// CarehomeUserEditForm.scp.html?9ecd5810